import $ from 'jquery';
import { scrollToElement } from '../lib/utilities';

$(() => {
  if ($('.sub-nav--anchor').length > 0) {
    $('.sub-nav--anchor a').on('click', function (event) {
      let $id = event.target.href.substring(
        event.target.href.lastIndexOf('/') + 1
      );
      scrollToElement($id);
    });
  }
});
